import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard, Search, Upload, BookOpen, Users, LogOut, Radio
} from "lucide-react";
import { Button } from "./ui/button";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin", "analis", "viewer"] },
  { to: "/search", label: "Pencarian", icon: Search, roles: ["admin", "analis", "viewer"] },
  { to: "/upload", label: "Ingest", icon: Upload, roles: ["admin", "analis"] },
  { to: "/keywords", label: "Kamus Keyword", icon: BookOpen, roles: ["admin", "analis", "viewer"] },
  { to: "/users", label: "Pengguna", icon: Users, roles: ["admin"] },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const visibleNav = NAV.filter((n) => n.roles.includes(user.role));

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex">
      <aside className="w-60 border-r border-slate-200 bg-white flex flex-col" data-testid="sidebar">
        <div className="px-5 py-5 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-sm bg-slate-900 text-white flex items-center justify-center">
              <Radio className="h-4 w-4" />
            </div>
            <div>
              <p className="text-sm font-bold tracking-tight">GardaMedia</p>
              <p className="text-[10px] uppercase tracking-wider text-slate-500">TV Intel Monitor</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-3 px-2 space-y-0.5">
          {visibleNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.slice(1)}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${
                  isActive
                    ? "bg-slate-900 text-white"
                    : "text-slate-700 hover:bg-slate-100"
                }`
              }
            >
              <item.icon className="h-4 w-4" strokeWidth={2} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-slate-200 px-3 py-3 space-y-2">
          <div className="px-2">
            <p className="text-sm font-medium text-slate-900 truncate" data-testid="sidebar-user-name">{user.name}</p>
            <p className="text-[11px] uppercase tracking-wider text-slate-500" data-testid="sidebar-user-role">{user.role}</p>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="w-full justify-start rounded-sm border-slate-300 hover:bg-slate-100"
            onClick={handleLogout}
            data-testid="logout-button"
          >
            <LogOut className="h-4 w-4 mr-2" /> Keluar
          </Button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-x-hidden">
        {children}
      </main>
    </div>
  );
}
